import moment from 'moment'

export default (start, end) => moment.duration(end.diff(start))
